<template>
  <v-card
    flat
    outlined
    rounded="lg"
    height="100%"
    color="cardbg"
    class="flex"
    elevation="10"
  >
<v-card-title
      color="primary"
      :style="`
        padding: calc(${scale} * 0.4rem);
        line-height: calc(${scale} * 0.75rem)
      `"
      class="font-weight-medium titlecolor--text d-flex justify-space-between"
    >
      <div :style="`font-size: calc(${scale} * 0.7rem);
       display: flex; align-items: center; gap: 8px;`">
        <span
          v-if="title && title.includes('Live')"
          :class="['live-title', { 'live-title--empty': noData }]"
        >
          {{ title }}
        </span>
        <span v-else>{{ title }}</span>
      </div>

      <span class="subtitlecolor--text" :style="`font-size: calc(${scale} * 0.7rem);`">
        {{ daterange }}
      </span>
    </v-card-title>
    <v-card-text
      :style="`padding: calc(${scale} * 0.25rem);`"
      style="height: 90%; line-height: normal;"
    >
      <WidgetLoading v-if="loading" />
      <div
        v-else-if="noData"
        class="subtitlecolor--text d-flex align-center justify-center"
        style="height: 100%; width: 100%;"
        :style="`font-size: calc(${scale} * 0.75rem);`"
      >
        No Data Available
      </div>
      <highcharts
        :options="options"
        style="height: 100%; width: 100%;"
        :key="uuid"
        v-else
      ></highcharts>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import WidgetLoading from './WidgetLoading.vue';

export default {
  name: 'StackChart',
  props: {
    title: { type: String },
    daterange: { type: String },
    scale: { type: Number, default: 1 },
    unit: { type: String },
    loading: { type: Boolean, default: false },
    bgcolor: { type: String, default: '#0e1824' },
  },
  components: { WidgetLoading },
  data() {
    return {
      uuid: 'uuid',
      options: {
        chart: {
          type: 'column',
          backgroundColor: 'transparent',
          style: {
            fontFamily: 'Poppins, "Open Sans", sans-serif',
          },
        },
        title: { text: '' },
        xAxis: { categories: [], labels: { style: {} } },
        yAxis: { min: 0, title: { text: '' }, labels: { style: {} } },
        legend: { enabled: false },
        plotOptions: {
          column: { stacking: 'normal', dataLabels: { enabled: true } },
          series: { borderWidth: 0 },
        },
        series: [],
      },
    };
  },
  computed: {
    ...mapState('cellwiseDowntimeDashboard', ['theme']),
    activeTheme() {
      return this.$vuetify.theme.dark ? 'dark' : 'light';
    },
    noData() {
      if (!this.options || !Array.isArray(this.options.series)) return true;
      return !this.options.series.some((series) => (
        Array.isArray(series.data) && series.data.some((value) => {
          const amount = typeof value === 'object' ? value.y : value;
          return Number(amount) > 0;
        })
      ));
    },
  },
  watch: {
    scale: {
      immediate: true,
      handler(val) {
        this.adjustSize(val);
        this.createUUID();
      },
    },
    activeTheme: {
      immediate: true,
      handler() {
        this.adjustSize(this.scale);
        this.createUUID();
      },
    },
  },
  methods: {
    assignData(result) {
      if (result && result.series) {
        this.options.xAxis.categories = result.categories || ['-'];
        this.options.series = result.series;
      } else {
        this.options.xAxis.categories = ['-'];
        this.options.series = [];
      }
      this.createUUID();
    },
    adjustSize(scale) {
      if (!scale) return;
      const lablesize = 9 * scale;
      const padding = 15 * scale;

      const isDark = this.$vuetify.theme.dark;

      let textColor = isDark ? '#FFFFFF' : '#15191E';
      const gridColor = isDark ? '#495767' : '#E0E0E0';

      if (this.theme && this.theme.themes && this.theme.themes[isDark ? 'dark' : 'light']) {
        const customTitleColor = this.theme.themes[isDark ? 'dark' : 'light'].titlecolor;

        if (isDark) {
          textColor = customTitleColor;
        } else if (customTitleColor !== '#FFFFFF') {
          textColor = customTitleColor;
        }
      }

      this.options = {
        ...this.options,
        xAxis: {
          ...this.options.xAxis,
          labels: {
            reserveSpace: true,
            y: padding,
            style: {
              color: textColor, fontSize: `${lablesize}px`, fontWeight: 'normal', fontFamily: 'Poppins, "Open Sans", sans-serif',
            },
          },
        },
        yAxis: {
          ...this.options.yAxis,
          gridLineColor: gridColor,
          labels: {
            style: {
              color: textColor, fontSize: `${lablesize}px`, fontWeight: 'normal', fontFamily: 'Poppins, "Open Sans", sans-serif',
            },
          },
        },
        plotOptions: {
          ...this.options.plotOptions,
          column: {
            ...this.options.plotOptions.column,
            dataLabels: {
              enabled: true,
              formatter() {
                return this.y > 0 ? this.y : null;
              },
              style: {
                fontSize: `${lablesize}px`,
                color: '#FFFFFF',
                textOutline: '1px contrast',
                fontFamily: 'Poppins, "Open Sans", sans-serif',
              },
            },
          },
        },
      };
    },
    createUUID() {
      let dt = new Date().getTime();
      const newUuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.floor((dt + Math.random() * 16) % 16);
        dt = Math.floor(dt / 16);
        return (c === 'x' ? r : (r % 4) + 8).toString(16);
      });
      this.uuid = newUuid;
    },
  },
};
</script>
<style lang="scss" scoped>
.live-title {
  display: inline-block;
  font-family: inherit;
  color: #00E676;
  font-weight: normal;
  line-height: 1;
}

.live-title--empty {
  color: #FF5252;
  text-shadow: 0 0 8px #FF5252;
}
</style>
